module.exports = __webpack_public_path__ + "img/60e5282.png";